import React, { createContext, useContext, useState, type ReactNode } from 'react';
import type { Language } from './types';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const initialLanguage = localStorage.getItem('language') ?? 'valueEnglish';
  const [language, setLanguageState] = useState<Language>(initialLanguage as Language);

  const setLanguage: LanguageContextType['setLanguage'] = (lang) => {
    setLanguageState(lang);
  };

  const contextValue: LanguageContextType = {
    language,
    setLanguage
  };

  return React.createElement(
    LanguageContext.Provider,
    { value: contextValue },
    children as React.ReactNode
  );
};
